<template>
    <div>
        <v-row align="center" dense>
            <v-col cols="12" md="4">
                <span class="font-weight-medium mr-4">
                    {{ $t("views.trips.create_trip.routes_to_choose") }}:
                </span>
                <v-radio-group v-model="selected" row>
                    <v-radio :label="$t('views.trips.create_trip.master_route')" value="master" class="mr-6" />
                    <v-radio :label="$t('views.trips.create_trip.suggested_route')" value="suggested" />
                </v-radio-group>
            </v-col>
        </v-row>
        <v-row v-if="routes.length > 0" class="mt-4">
            <v-col cols="12">
                <v-list dense>
                    <v-list-item v-for="(route, i) in routes" :key="route.id" class="hoverable">
                        <v-list-item-action>
                            <v-switch :input-value="selectedRouteIndex === i" @change="() => selectRoute(route, i)"
                                inset color="orange darken-2" />
                        </v-list-item-action>
                        <v-list-item-content @click="selectRoute(route, i)">
                            <v-list-item-title>{{ route.code || 'Sin código' }}</v-list-item-title>
                            <v-list-item-subtitle>{{ route.origin || route.cityOrigin }}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{ route.destiny || route.cityDestination }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
        <v-row v-else class="mt-2">
            <v-col cols="12">
                <p class="text-body-2 grey--text font-italic">
                    {{ $t("views.trips.create_trip.no_routes_found") }}
                </p>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        stops: {
            type: Array,
            required: true,
        },
        selectedOption: {
            type: String,
            default: "suggested",
        }
    },
    data() {
        return {
            routes: [],
            selectedRouteIndex: null
        };
    },
    emits: ["view-map", "open-observations", "open-references", "update:selectedOption"],
    computed: {
        selected: {
            get() {
                return this.selectedOption;
            },
            set(value) {
                this.$emit("update:selectedOption", value);

                if (value === "suggested") {
                    this.fetchSuggestedRoute();
                }
                if (value === "master") {
                    this.fetchMasterRoute();
                }
            }
        }
    },
    watch: {
        stops: {
            immediate: true,
            deep: true,
            handler(newVal) {
             
            }
        }
    },
    methods: {
        selectRoute(route, index) {
            this.selectedRouteIndex = index;

            this.$emit("update:route", {
                id_route: route.code || '',
                name_route: route.name || '',
            });
        },

        async fetchMasterRoute() {
            const originStop = this.stops.find(s =>
                ['origen', 'origin'].includes((s.type_location || '').toLowerCase())
            );
            const destinationStop = this.stops.find(s =>
                ['destino', 'destination'].includes((s.type_location || '').toLowerCase())
            );
            const idCityOrigin = originStop?.id_city || null;
            const idCityDestination = destinationStop?.id_city || null;

            if (!idCityOrigin || !idCityDestination) {
                console.warn(" No se encontraron idCity válidos para origen y destino.");
                return;
            }

            try {
                const res = await this.axios.get(
                    `https://tower-api.controlt.com.co/Tracking/Route/Master/${idCityOrigin}/${idCityDestination}`
                );

                this.routes = res.data || []
            } catch (err) {
                console.error(" Error al obtener ruta maestra:", err);
            }
        },
        async fetchSuggestedRoute() {
            console.log(" ruta sugerida Escogida");
        }
    }
};
</script>
